// ============================================================================
// SPANISH TRANSLATIONS - CHAPTER 5: LA IGLESIA PRIMITIVA
// ============================================================================
// Niveles 53-65 (13 niveles, 39 preguntas)

export const chapter5Translations = {
  name: "La Iglesia Primitiva",
  description: "Recibiréis poder...",
  
  spiritualWisdom: {
    principle: "El Espíritu Santo da poder y valentía para testificar",
    scripture: "Recibiréis poder, cuando haya venido sobre vosotros el Espíritu Santo, y me seréis testigos (Hechos 1:8)",
    application: "La Iglesia nace en el fuego del Espíritu y crece por el testimonio valiente"
  },
  
  levels: {
    53: {
      name: "La Ascensión",
      challenge: "Seréis mis testigos... hasta lo último de la tierra...",
      easy: {
        question: "¿Cuántos días después de su resurrección ascendió Jesús al cielo?",
        options: ["30 días", "40 días", "50 días", "60 días"],
        hint: "El número bíblico de preparación",
        funFact: "☁️ ¡40 días de enseñanza intensiva antes de la misión mundial!"
      },
      medium: {
        question: "¿Qué promesa hace Jesús antes de ascender al cielo?",
        options: [
          "Volverá pronto",
          "Enviará el Espíritu Santo con poder",
          "Construirá una iglesia",
          "Castigará a los malvados"
        ],
        hint: "Un poder de lo alto",
        funFact: "⚡ ¡Promesa del Espíritu Santo - transformación de discípulos temerosos!"
      },
      hard: {
        question: "¿Qué simboliza la Ascensión en nuestra vida espiritual?",
        options: [
          "El fin de la presencia de Jesús",
          "Jesús reina e intercede por nosotros en el cielo",
          "Una separación definitiva",
          "Un mito simbólico"
        ],
        hint: "Se trata de su presencia glorificada y activa",
        funFact: "👑 ¡Jesús reina a la diestra de Dios e intercede por nosotros!"
      }
    },
    
    54: {
      name: "Pentecostés",
      challenge: "Fueron todos llenos del Espíritu Santo y comenzaron a hablar...",
      easy: {
        question: "¿Cuántos días después de la Ascensión tuvo lugar Pentecostés?",
        options: ["7 días", "10 días", "14 días", "20 días"],
        hint: "Una decena de días",
        funFact: "🔟 ¡10 días de oración intensa preparan para el derramamiento del Espíritu!"
      },
      medium: {
        question: "¿Bajo qué forma apareció el Espíritu Santo?",
        options: [
          "Como un viento recio",
          "Como lenguas de fuego",
          "Como una paloma",
          "Como una luz"
        ],
        hint: "Llamas que se posan sobre cada discípulo",
        funFact: "🔥 ¡Lenguas de fuego: el Espíritu da valentía y don de lenguas!"
      },
      hard: {
        question: "¿Qué representa Pentecostés para la Iglesia universal?",
        options: [
          "Un evento histórico aislado",
          "El nacimiento oficial de la Iglesia misionera",
          "Un milagro de curiosidad",
          "El comienzo de las celebraciones"
        ],
        hint: "Se trata del acta de nacimiento de la Iglesia",
        funFact: "🎂 ¡Pentecostés = cumpleaños de la Iglesia, inicio de la misión mundial!"
      }
    },

    55: {
      name: "El Primer Sermón de Pedro",
      challenge: "¿Qué haremos, varones hermanos? Arrepentíos...",
      easy: {
        question: "¿Cuántas personas fueron bautizadas después del sermón de Pedro?",
        options: ["1000", "2000", "3000", "5000"],
        hint: "Tres mil almas",
        funFact: "🌊 ¡3000 bautismos en un día - despertar espiritual extraordinario!"
      },
      medium: {
        question: "¿De qué acusó Pedro a la multitud?",
        options: [
          "De ignorancia",
          "De haber crucificado a Jesús, el Mesías",
          "De falta de fe",
          "De hipocresía"
        ],
        hint: "El crimen supremo contra el Hijo de Dios",
        funFact: "⚔️ ¡Pedro, que había negado a Jesús, ahora proclama su divinidad!"
      },
      hard: {
        question: "¿Cómo ilustra la transformación de Pedro la obra del Espíritu Santo?",
        options: [
          "Se vuelve más instruido",
          "De cobarde e inestable, se vuelve valiente y firme en la fe",
          "Adquiere poderes",
          "Cambia de personalidad"
        ],
        hint: "Se trata de la santificación por el Espíritu",
        funFact: "🗿 ¡La 'caña sacudida' se vuelve 'piedra firme' - poder transformador!"
      }
    },

    56: {
      name: "La Primera Comunidad",
      challenge: "Perseveraban en la doctrina de los apóstoles, en la comunión...",
      easy: {
        question: "¿Cómo compartían sus bienes los primeros cristianos?",
        options: [
          "Cada uno guardaba lo suyo",
          "Tenían todo en común",
          "Solo los ricos daban",
          "Por obligación legal"
        ],
        hint: "Comunidad de bienes voluntaria",
        funFact: "🤝 ¡Amor fraternal tan intenso que comparten todo espontáneamente!"
      },
      medium: {
        question: "¿A qué dedicaban su tiempo los primeros cristianos?",
        options: [
          "Solo a los negocios",
          "Doctrina, comunión, partimiento del pan, oraciones",
          "Solo al trabajo",
          "Al ocio"
        ],
        hint: "Cuatro pilares de la vida comunitaria",
        funFact: "⛪ ¡Doctrina, comunión, eucaristía, oración - fundamentos de la Iglesia!"
      },
      hard: {
        question: "¿Por qué esta primera comunidad era tan atractiva?",
        options: [
          "Era rica",
          "El amor auténtico y la alegría irradiaban de su unidad",
          "Prometía milagros",
          "Criticaba a otros"
        ],
        hint: "Se trata del testimonio del amor vivido",
        funFact: "✨ ¡'¡Mirad cómo se aman!' - testimonio que convence más que las palabras!"
      }
    },

    57: {
      name: "La Curación del Cojo",
      challenge: "No tengo plata ni oro; pero lo que tengo te doy...",
      easy: {
        question: "¿Desde cuándo el hombre era cojo?",
        options: [
          "Desde hace 20 años",
          "Desde hace 30 años", 
          "Desde su nacimiento",
          "Desde hace 10 años"
        ],
        hint: "Una enfermedad de siempre",
        funFact: "🚶 ¡40 años de enfermedad curados instantáneamente en el nombre de Jesús!"
      },
      medium: {
        question: "¿En nombre de quién Pedro sanó al cojo?",
        options: [
          "En el nombre de Dios",
          "En el nombre de Jesucristo de Nazaret",
          "En su propio nombre",
          "En el nombre de Abraham"
        ],
        hint: "El nombre sobre todo nombre",
        funFact: "✊ ¡El nombre de Jesús continúa obrando milagros a través de los apóstoles!"
      },
      hard: {
        question: "¿Qué simboliza esta curación para el Evangelio?",
        options: [
          "Un simple milagro médico",
          "La salvación total que Jesús trae: espiritual y física",
          "El poder de los apóstoles",
          "La caridad hacia los pobres"
        ],
        hint: "Se trata de la salvación integral del ser humano",
        funFact: "🩺 ¡Jesús sana el alma y el cuerpo - salvación completa de la persona!"
      }
    },

    58: {
      name: "Comienza la Persecución",
      challenge: "Es necesario obedecer a Dios antes que a los hombres...",
      easy: {
        question: "¿Quién arrestó a Pedro y Juan después de la curación del cojo?",
        options: [
          "Los romanos",
          "Los saduceos y sacerdotes",
          "El pueblo",
          "Pilato"
        ],
        hint: "Las autoridades religiosas judías",
        funFact: "⛓️ ¡Primera persecución religiosa - el Evangelio perturba el establishment!"
      },
      medium: {
        question: "¿Qué prohibición dieron las autoridades a los apóstoles?",
        options: [
          "Salir de Jerusalén",
          "No enseñar más en el nombre de Jesús",
          "No hacer más milagros",
          "No orar más"
        ],
        hint: "Prohibición de predicar",
        funFact: "🚫 ¡Intentan silenciar la verdad - imposible detener el Evangelio!"
      },
      hard: {
        question: "¿Cómo reaccionaron los apóstoles ante la prohibición?",
        options: [
          "Obedecieron por miedo",
          "Afirmaron que debían obedecer a Dios antes que a los hombres",
          "Negociaron",
          "Huyeron"
        ],
        hint: "Se trata de una fidelidad más alta que las leyes humanas",
        funFact: "⚖️ ¡Desobediencia civil para obedecer a Dios - valentía de la convicción!"
      }
    },

    59: {
      name: "Ananías y Safira",
      challenge: "No has mentido a los hombres, sino a Dios...",
      easy: {
        question: "¿Qué mentira dijeron Ananías y Safira?",
        options: [
          "No habían vendido nada",
          "Daban todo el precio de su venta cuando guardaban una parte",
          "Eran pobres",
          "No estaban casados"
        ],
        hint: "Mentira sobre la cantidad dada",
        funFact: "💰 ¡Guardar una parte estaba permitido, mentir sobre la ofrenda no!"
      },
      medium: {
        question: "¿Qué les sucedió después de su mentira?",
        options: [
          "Fueron perdonados",
          "Murieron súbitamente",
          "Fueron excluidos",
          "Se arrepintieron"
        ],
        hint: "Castigo inmediato y severo",
        funFact: "⚱️ ¡Juicio severo para preservar la pureza de la Iglesia naciente!"
      },
      hard: {
        question: "¿Por qué este castigo tan severo al principio de la Iglesia?",
        options: [
          "Dios era cruel",
          "Para establecer la santidad requerida en la comunidad",
          "Para dar miedo",
          "Por accidente"
        ],
        hint: "Se trata de preservar la integridad espiritual",
        funFact: "🔥 ¡Estándares altos al principio para establecer cultura de santidad!"
      }
    },

    60: {
      name: "Los Siete Diáconos",
      challenge: "Escoged de entre vosotros siete varones de buen testimonio...",
      easy: {
        question: "¿Cuántos diáconos fueron escogidos?",
        options: ["5", "6", "7", "12"],
        hint: "El número de la perfección",
        funFact: "7️⃣ ¡Siete diáconos para el servicio - organización divina de la Iglesia!"
      },
      medium: {
        question: "¿Cuál era su función principal?",
        options: [
          "Predicar el Evangelio",
          "Servir a las mesas y ayudar a las viudas",
          "Bautizar a los nuevos convertidos",
          "Administrar las finanzas"
        ],
        hint: "Servicio social y material",
        funFact: "🍽️ ¡Servicio de mesas = primera organización caritativa cristiana!"
      },
      hard: {
        question: "¿Qué revela esta organización sobre la visión cristiana del servicio?",
        options: [
          "Las tareas materiales son inferiores",
          "Servicio espiritual y material son ambos sagrados",
          "Hay que separar lo sagrado de lo profano",
          "Solo los sacerdotes sirven verdaderamente"
        ],
        hint: "Se trata de la sacralidad de todo servicio de amor",
        funFact: "✨ ¡Servir a las mesas con la misma dignidad que predicar - todo servicio es sagrado!"
      }
    },

    61: {
      name: "Esteban, Primer Mártir",
      challenge: "Señor, no les tomes en cuenta este pecado! Y habiendo dicho esto, durmió...",
      easy: {
        question: "¿Cuál era la función de Esteban en la Iglesia?",
        options: ["Apóstol", "Diácono", "Sacerdote", "Profeta"],
        hint: "Uno de los siete escogidos para servir",
        funFact: "✨ ¡Esteban: diácono se convirtió en evangelista poderoso y primer mártir!"
      },
      medium: {
        question: "¿De qué acusó Esteban a los líderes judíos?",
        options: [
          "De corrupción",
          "De haber resistido siempre al Espíritu Santo",
          "De hipocresía",
          "De codicia"
        ],
        hint: "Resistencia histórica a Dios",
        funFact: "📜 ¡Esteban resume la historia: rebelión constante contra Dios!"
      },
      hard: {
        question: "¿Cómo murió Esteban y qué revela su actitud?",
        options: [
          "En ira contra sus verdugos",
          "Perdonando como Jesús en la cruz",
          "En desesperación",
          "Maldiciendo a sus enemigos"
        ],
        hint: "Se trata de la imitación perfecta de Cristo",
        funFact: "💝 ¡Perdón de verdugos: Esteban reproduce perfectamente la actitud de Jesús!"
      }
    },

    62: {
      name: "Felipe y el Eunuco Etíope",
      challenge: "¿Cómo podré entender si alguien no me guía?",
      easy: {
        question: "¿Qué estaba leyendo el eunuco en su carro?",
        options: [
          "Los Salmos",
          "El profeta Isaías",
          "El Génesis",
          "Los Proverbios"
        ],
        hint: "El profeta de la Pasión del Mesías",
        funFact: "📖 ¡Isaías 53 - profecía perfecta de Jesús leída por un buscador sincero!"
      },
      medium: {
        question: "¿Cómo explicó Felipe el pasaje de Isaías?",
        options: [
          "Habló de historia antigua",
          "Anunció a Jesús a partir de este texto",
          "Dio una lección de teología",
          "Criticó las interpretaciones"
        ],
        hint: "La Escritura conduce naturalmente a Cristo",
        funFact: "✝️ ¡Toda la Escritura converge hacia Jesús - clave de comprensión!"
      },
      hard: {
        question: "¿Qué simboliza la conversión del eunuco etíope?",
        options: [
          "Una conversión aislada",
          "La universalidad del Evangelio para todas las razas y condiciones",
          "La superioridad de ciertos pueblos",
          "Un caso particular"
        ],
        hint: "Se trata de la apertura a las naciones",
        funFact: "🌍 ¡Etíope, eunuco, ministro: el Evangelio rompe todas las barreras!"
      }
    },

    63: {
      name: "La Conversión de Saulo de Tarso",
      challenge: "Saulo, Saulo, ¿por qué me persigues?",
      easy: {
        question: "¿Qué hacía Saulo antes de su conversión?",
        options: [
          "Predicaba el Evangelio",
          "Perseguía a los cristianos",
          "Era neutral",
          "Solo estudiaba"
        ],
        hint: "Enemigo encarnizado de los discípulos",
        funFact: "⚔️ ¡Saulo respiraba amenazas y muerte contra los discípulos de Jesús!"
      },
      medium: {
        question: "¿En qué camino Jesús se apareció a Saulo?",
        options: [
          "El camino de Jerusalén",
          "El camino de Damasco",
          "El camino de Gaza",
          "El camino de Antioquía"
        ],
        hint: "Una ciudad de Siria",
        funFact: "🛤️ ¡Camino de Damasco = lugar de transformación más famoso de la historia!"
      },
      hard: {
        question: "¿Cómo ilustra esta conversión la gracia divina?",
        options: [
          "Dios convierte solo a los buenos",
          "La gracia puede transformar al peor enemigo en el mayor apóstol",
          "La conversión fue merecida",
          "Saulo ya estaba cerca de Dios"
        ],
        hint: "Se trata del poder transformador de la gracia",
        funFact: "⚡ ¡Del mayor perseguidor al mayor misionero - milagro de gracia!"
      }
    },

    64: {
      name: "Pedro y Cornelio",
      challenge: "En verdad comprendo que Dios no hace acepción de personas...",
      easy: {
        question: "¿Cuál era la profesión de Cornelio?",
        options: [
          "Comerciante",
          "Centurión romano",
          "Sacerdote",
          "Escriba"
        ],
        hint: "Oficial del ejército romano",
        funFact: "🎖️ ¡Primer gentil convertido oficialmente - apertura a los no judíos!"
      },
      medium: {
        question: "¿Qué visión tuvo Pedro antes de encontrarse con Cornelio?",
        options: [
          "Un ángel hablándole",
          "Un lienzo con animales puros e impuros",
          "Jesús apareciéndole",
          "Un templo destruido"
        ],
        hint: "Visión sobre la pureza e impureza",
        funFact: "🕊️ ¡Lienzo con animales: Dios abolió las distinciones alimentarias y raciales!"
      },
      hard: {
        question: "¿Qué principio revolucionario estableció esta conversión?",
        options: [
          "Los romanos son superiores",
          "Dios no hace acepción de personas - salvación universal",
          "Hay que abandonar las tradiciones",
          "La circuncisión es inútil"
        ],
        hint: "Se trata de la universalidad de la salvación",
        funFact: "🌍 ¡Revolución espiritual: el Evangelio es para todos los pueblos sin excepción!"
      }
    },

    65: {
      name: "La Iglesia de Antioquía",
      challenge: "En Antioquía los discípulos fueron llamados cristianos por primera vez...",
      easy: {
        question: "¿Cómo se llamó a los discípulos por primera vez en Antioquía?",
        options: ["Discípulos", "Cristianos", "Fieles", "Santos"],
        hint: "El nombre que aún llevamos hoy",
        funFact: "✝️ ¡'Cristianos' = 'pequeños Cristos' - nombre de honor dado por paganos!"
      },
      medium: {
        question: "¿Quién vino a enseñar en Antioquía con Bernabé?",
        options: [
          "Pedro",
          "Pablo (Saulo)",
          "Santiago",
          "Juan"
        ],
        hint: "El antiguo perseguidor convertido en apóstol",
        funFact: "👥 ¡Bernabé busca a Pablo en Tarso - inicio del ministerio paulino!"
      },
      hard: {
        question: "¿Por qué Antioquía se volvió tan importante en la historia cristiana?",
        options: [
          "Era rica",
          "Primer centro misionero hacia los gentiles",
          "Estaba bien situada",
          "Tenía buenos líderes"
        ],
        hint: "Se trata de la expansión misionera",
        funFact: "🚢 ¡Antioquía: puerto de lanzamiento de todas las misiones de Pablo hacia Europa!"
      }
    }
  }
};

export default chapter5Translations;
